<template>
  <section class="page"></section>
</template>

<script>

export default {
  name: "auth-yandex",
  methods: {
    addSuggest() {
        var script = document.createElement('script');
        script.src = "https://yastatic.net/s3/passport-sdk/autofill/v1/sdk-suggest-token-latest.js";
        document.getElementsByTagName('head')[0].appendChild(script);
    }
  },
  async created() {
    await this.addSuggest()
    setTimeout(() => {
        window.YaSendSuggestToken('https://wiildwood.online', null)
    }, 300)
  }
};
</script>
